var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "registerForm",
      attrs: { model: _vm.form, rules: _vm.rules },
      nativeOn: {
        keyup: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          return _vm.onSubmit.apply(null, arguments)
        },
      },
    },
    [
      !_vm.isLogged
        ? _c("p", { staticClass: "orangetext" }, [
            _vm._v(
              "\n        Create your account in order to submit your project for " +
                _vm._s(_vm.currentAwardName) +
                ".\n        You can use the same account for all Global Design News awards submissions.\n    "
            ),
          ])
        : _c("p", { staticClass: "orangetext" }, [
            _vm._v(
              "\n        You can edit your account changing basic information below. Remember this account is connected with all your\n        past and future submissions to\n        " +
                _vm._s(_vm.currentAwardName) +
                ".\n    "
            ),
          ]),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { sm: 24, md: 12 } },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "form-group",
                  attrs: {
                    prop: "first_name",
                    error: _vm.$t(_vm.formErrors.get("first_name")),
                  },
                },
                [
                  _c("InputWh", {
                    attrs: {
                      placeholder: "first_name",
                      required: _vm.rules["first_name"][0].required,
                    },
                    model: {
                      value: _vm.form.first_name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "first_name", $$v)
                      },
                      expression: "form.first_name",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { sm: 24, md: 12 } },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "form-group",
                  attrs: {
                    prop: "last_name",
                    error: _vm.$t(_vm.formErrors.get("last_name")),
                  },
                },
                [
                  _c("InputWh", {
                    attrs: {
                      placeholder: "last_name",
                      required: _vm.rules["first_name"][0].required,
                    },
                    model: {
                      value: _vm.form.last_name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "last_name", $$v)
                      },
                      expression: "form.last_name",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { sm: 24, md: 12 } },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "form-group",
                  attrs: {
                    prop: "email",
                    error: _vm.$t(_vm.formErrors.get("email")),
                  },
                },
                [
                  _c("InputWh", {
                    attrs: {
                      placeholder: "email",
                      required: _vm.rules["email"][0].required,
                    },
                    model: {
                      value: _vm.form.email,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "email", $$v)
                      },
                      expression: "form.email",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { sm: 24, md: 12 } },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "form-group",
                  attrs: {
                    prop: "phone",
                    error: _vm.$t(_vm.formErrors.get("phone")),
                  },
                },
                [
                  _c("InputWh", {
                    attrs: {
                      placeholder: "phone",
                      required: _vm.rules["phone"][0].required,
                    },
                    model: {
                      value: _vm.form.phone,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "phone", $$v)
                      },
                      expression: "form.phone",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { sm: 24, md: 12 } },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "form-group",
                  attrs: {
                    prop: "password",
                    error: _vm.$t(_vm.formErrors.get("password")),
                    rules: [
                      {
                        required: !_vm.isLogged,
                        message: "Password is required",
                        trigger: "blur",
                      },
                      {
                        min: 8,
                        message: "Password should be at least 8 characters",
                        trigger: "blur",
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: _vm.$t("auth.register.password_label") + "*",
                      name: "password",
                      "show-password": "",
                    },
                    model: {
                      value: _vm.form.password,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "password", $$v)
                      },
                      expression: "form.password",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { sm: 24, md: 12 } },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "form-group",
                  attrs: {
                    prop: "password_confirmation",
                    rules: [
                      {
                        required: !_vm.isLogged,
                        message: "Password Confirmation is required",
                        trigger: "blur",
                      },
                      {
                        validator: _vm.validatePassConfirmation,
                        trigger: "blur",
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder:
                        _vm.$t("auth.register.password_confirmation_label") +
                        "*",
                      name: "password_confirmation",
                      "show-password": "",
                    },
                    model: {
                      value: _vm.form.password_confirmation,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "password_confirmation", $$v)
                      },
                      expression: "form.password_confirmation",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { sm: 24, md: 12 } },
            [
              _c(
                "el-form-item",
                [
                  _c(
                    "el-checkbox",
                    {
                      model: {
                        value: _vm.form.newsletter,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "newsletter", $$v)
                        },
                        expression: "form.newsletter",
                      },
                    },
                    [_vm._v("Subscribe to GDN mailing list")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { sm: 24, md: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "privacy" } },
                [
                  _c(
                    "el-checkbox",
                    {
                      model: {
                        value: _vm.form.privacy,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "privacy", $$v)
                        },
                        expression: "form.privacy",
                      },
                    },
                    [
                      _vm._v("I have read and agreed with the "),
                      _c("a", { attrs: { href: "#", target: "_blank" } }, [
                        _vm._v("Privacy\n                    Policy"),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { sm: 24, md: 12 } }, [
            _vm._v("\n             \n        "),
          ]),
          _vm._v(" "),
          _c(
            "el-col",
            { staticClass: "text-right", attrs: { sm: 24, md: 12 } },
            [
              !_vm.isLogged
                ? _c(
                    "el-button",
                    {
                      attrs: { loading: _vm.loading },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.onSubmit.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("auth.register.submit_button")) +
                          "\n            "
                      ),
                    ]
                  )
                : _c(
                    "el-button",
                    {
                      attrs: { loading: _vm.loading },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.onSubmit.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("auth.register.save")) +
                          "\n            "
                      ),
                    ]
                  ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }